module.exports = __webpack_public_path__ + "static/media/woods.128da400.pdf";